import { render, staticRenderFns } from "./ClassFeaturesPanel.vue?vue&type=template&id=baeffbbe"
import script from "./ClassFeaturesPanel.vue?vue&type=script&lang=js"
export * from "./ClassFeaturesPanel.vue?vue&type=script&lang=js"
import style0 from "./ClassFeaturesPanel.vue?vue&type=style&index=0&id=baeffbbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports